// NOTE
// it cotains a Exchange information and HollaEx-USDT exchange rate.
import {
	READ_STAT,
	CREATE_STAT,
	UPDATE_STAT_REQUEST,
	UPDATE_STAT_SUCCESS,
	UPDATE_STAT_FAILURE,
	DELETE_STAT
} from '../config/actionTypes';

const initialState = {
	amount: 0,
	xht_price: 0,
	no: 0,
	price: 0,
	isLoading: false
};

const StatReducer = (state = initialState, action) => {
	switch (action.type) {
		case READ_STAT:
			const { data } = action;
			return data;
		case CREATE_STAT:
			return state;
		case UPDATE_STAT_REQUEST:
			return { ...state, isLoading: true };
		case UPDATE_STAT_SUCCESS:
			const newData = {
				...state,
				...action.data,
				isLoading: false
			};
			return newData;
		case UPDATE_STAT_FAILURE:
			return { ...state, isLoading: false };
		case DELETE_STAT:
			return state;
		default:
			return state;
	}
};

export default StatReducer;
